import React from 'react';
import { Schema } from './Schema';
import { SchemaHelpers } from '../helpers';
export var Extensions = function (_a) {
    var _b = _a.name, name = _b === void 0 ? 'Extensions' : _b, item = _a.item;
    var extensions = SchemaHelpers.getCustomExtensions(item);
    if (!extensions || !Object.keys(extensions).length) {
        return null;
    }
    var schema = SchemaHelpers.jsonToSchema(extensions);
    return (React.createElement("div", { className: "mt-2" },
        React.createElement(Schema, { schemaName: name, schema: schema })));
};
//# sourceMappingURL=Extensions.js.map